export default __webpack_public_path__ + "static/media/video-placeholder-bg.f7bdf083.png";